/** Scene 2 duration: 12 seconds (360 frames) */
export const SCENE_2_CONFIG = {
  DURATION: 360, // Full duration with anniversary effects
  DURATION_WITHOUT_ANNIVERSARY: 210, // Shorter duration when no confetti/ribbon
} as const;

/** Board entrance animation */
export const BOARD_ANIM = {
  DELAY: 0,
  SPRING_CONFIG: { damping: 15, stiffness: 80 },
  SCALE_START: 0.85,
} as const;

/** Background progressive zoom */
export const BACKGROUND_ZOOM = {
  SCALE_START: 1,
  SCALE_END: 1.5,
} as const;

/** Board background progressive zoom */
export const BOARD_ZOOM = {
  SCALE_START: 1,
  SCALE_END: 1.25,
} as const;

/** Card dealing animation */
export const CARD_DEALING = {
  STAGGER: 15,
  DEALING_START_X: -200,
  DEALING_START_Y: 300,
  ROTATION_DURING_DEAL: 45,
  OPACITY_DURATION_RATIO: 0.5,
} as const;

/** Polaroid animation */
export const POLAROID_ANIM = {
  DELAY: 45,
  DURATION: 30,
  SPRING_CONFIG: { damping: 18, stiffness: 50 },
  SCALE_START: 0.5,
  TRANSLATE_Z_START: -800,
  PERSPECTIVE: 1200,
} as const;

/** Stats blocks animation */
export const STATS_ANIM = {
  DELAY: 60,
  SPRING_CONFIG: { damping: 15, stiffness: 110 },
} as const;

/** Text reveal animation config */
export const TEXT_ANIM = {
  NAME_START: 30,
  ROLE_START: 60,
  DATE_LABEL_START: 90,
  DATE_VALUE_START: 100,
  CHARACTER_STAGGER: 2,
  COMPLETION: 130,
} as const;

/** Confetti animation timing */
export const CONFETTI_ANIM = {
  START: TEXT_ANIM.COMPLETION,
} as const;

/** Slide distances for various elements */
export const OFFSETS = {
  POLAROID_DROP: -1000,
  STATS_RIGHT: 120,
} as const;

export const CLAMP_RIGHT = {
  extrapolateRight: 'clamp',
} as const;

/** Flip counter animation timing */
export const FLIP_COUNTER_ANIM = {
  YEAR_START: STATS_ANIM.DELAY + 10,
  YEAR_DURATION: 60,
  MONTH_START: STATS_ANIM.DELAY + 30,
  MONTH_DURATION: 50,
  ANNIVERSARY_FLIP_BUFFER: 10,
} as const;

/** Anniversary text flip animation configuration */
export const ANNIVERSARY_ANIM = {
  FALL_DURATION: 15,
  RISE_DELAY: 15,
  RISE_DURATION: 20,
  PERSPECTIVE: 1000,
} as const;

export const RIBBON_ANIM_DELAY =
  FLIP_COUNTER_ANIM.MONTH_START +
  FLIP_COUNTER_ANIM.MONTH_DURATION +
  FLIP_COUNTER_ANIM.ANNIVERSARY_FLIP_BUFFER +
  ANNIVERSARY_ANIM.RISE_DELAY +
  ANNIVERSARY_ANIM.RISE_DURATION;
